var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00022 43.0005C8.22922 43.0005 7.58322 42.4155 7.50722 41.6485C7.43222 40.8805 7.94922 40.1805 8.70622 40.0295C19.2012 37.9305 19.9452 26.9965 19.7172 22.0005H12.0002C11.3942 22.0005 10.8472 21.6355 10.6142 21.0745C10.3812 20.5135 10.5102 19.8685 10.9392 19.4395L24.9392 5.4395C25.5252 4.8535 26.4742 4.8535 27.0602 5.4395L41.0602 19.4395C41.4892 19.8685 41.6182 20.5135 41.3852 21.0745C41.1522 21.6355 40.6062 22.0005 40.0002 22.0005H32.3052C31.5702 27.6335 27.8372 43.0005 9.00022 43.0005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrowUp);
export default __webpack_public_path__ + "static/media/white-arrow-up.63328d2932ae3982fe4f08c8e5b0ff43.svg";
export { ForwardRef as ReactComponent };